(ns app.domain.form.validators
  (:require #?(:clj [clojure.tools.logging :as log])
            [cloudpermit-commons.schemas.postal-code :as postal-code]
            [core.domain.schemas :as schemas]
            [potpuri.core :as p]
            [schema.core :as s]
            [schema.utils]))


(defn schema->checker
  "Values are ultimately encoded as edn, including nil for empty values (dates and numbers).
  Not allowing an empty value for required fields is validated separately"
  [schema]
  (let [checker (s/checker schema)]
    (fn [val] (some-> val checker))))


(def keyword-checker
  {:positive-integer     (schema->checker schemas/PositiveInteger)
   :positive-number      (schema->checker schemas/PositiveNumber)
   :non-negative-integer (schema->checker schemas/NonNegativeInteger)
   :non-negative-number  (schema->checker schemas/NonNegativeNumber)
   :CA-postal-code       (-> postal-code/postal-code-schemas :ca schema->checker)
   :US-ZIP-code          (-> postal-code/postal-code-schemas :us schema->checker)})

(defn checker [checker-kw]
  {:pre [(keyword? checker-kw)]}
  #_{:clj-kondo/ignore #?(:clj [] :cljs [:single-logical-operand])}
  (or (get keyword-checker
           checker-kw)
      #?(:clj (log/error "Undefined form field checker:" (name checker-kw)))))

(defn string-error [validation-error]
  (when validation-error
    (or (-> (schema.utils/validation-error-explain validation-error) second first)
        (pr-str validation-error))))

(defn luhn-valid?
  "Validate number `n` with Luhn algorithm checksum."
  [n]
  (-> (->> n
           str
           (keep (comp parse-long str))
           reverse
           (map-indexed (fn [i x]
                          (p/condas-> x result
                            (odd? i) (* result 2)
                            (> result 9) (- result 9))))
           (reduce +))
      (mod 10)
      zero?))

(def personal-id-validators
  {:CA luhn-valid?
   :US (partial re-matches #"^(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$")})
